<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Notifications</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a [routerLink]="getDashboardRoute()"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Notifications</li>
        </ol>
      </nav>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between">
      <h3>Notifications</h3>
      <div class="d-flex align-items-center">
        <div class="me-3">
          <div class="input-icon position-relative">
            <span class="input-icon-addon">
              <i class="ti ti-calendar text-gray-9"></i>
            </span>
            <!-- <input
              type="text"
              id="dateRangeInput"
              class="form-control date-range bookingrange"
              placeholder="dd/mm/yyyy - dd/mm/yyyy"
              [(ngModel)]="dateRange"
              (ngModelChange)="loadAppliedLeaves()"
              ngxDaterangepickerBootstrap
              [locale]="{ applyLabel: 'ok', format: 'DD-MM-YYYY' }"
              startKey="startDate"
              endKey="endDate"
              [opens]="'right'"
              [drops]="'down'"
              style="width: 210px"
            /> -->
            <input
              type="text"
              class="form-control date-range bookingrange"
              placeholder="dd/mm/yyyy - dd/mm/yyyy"
              [(ngModel)]="dateRange"
              (ngModelChange)="onDateChange()"
              ngxDaterangepickerBootstrap
              [locale]="{ applyLabel: 'ok', format: 'DD-MM-YYYY' }"
              startKey="startDate"
              endKey="endDate"
              [opens]="'right'"
              [drops]="'down'"
              style="width: 210px"
            />
          </div>
        </div>
        <div class="dropdown me-3">
          <input
            type="text"
            [(ngModel)]="search"
            (ngModelChange)="onSearchChange($event)"
            class="form-control"
            placeholder="Search Notifications"
          />
        </div>
      </div>
    </div>

    <div class="card-body">
      <!-- <div class="row"> -->
      <!-- <div class="custom-datatable-filter table-responsive">
          <ng-container *ngIf="notificationList.length > 0; else noRecords">
            <table class="table datatable" *ngIf="notificationList.length > 0">
              <thead class="thead-light">
                <tr>
                  <th>Title</th>
                  <th>Read</th>
                  <th>Date</th>
                  <th class="text-end">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let n of notificationList">
                  <td style="white-space: normal; word-break: break-word">{{ n.title }}</td>
                  <td>
                    <i *ngIf="n.isRead" class="ti ti-check text-success"></i>
                    <i *ngIf="!n.isRead" class="ti ti-x text-danger"></i>
                  </td>
                  <td>{{ n.createdAt | date: 'medium' }}</td>
                  <td class="text-end">
                    <div class="action-icon d-inline-flex">
                      <button
                        type="button"
                        class="btn btn-icon-style p-1 m-1"
                        aria-label="View item"
                        data-bs-toggle="modal"
                        data-bs-target="#notificationDetailsModal"
                        title="View"
                        (click)="openNotification(n)"
                      >
                        <i class="ti ti-eye"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-container>

          <ng-template #noRecords>
            <div class="text-center">Record not available</div>
          </ng-template>
        </div> -->
      <ng-container *ngIf="notificationList.length > 0; else noRecords">
        <div class="card ms-2" *ngFor="let notification of notificationList">
          <div class="card-body d-flex align-item-start justify-content-between">
            <div>
              <h6 class="fs-14 fw-medium text-truncate mb-1">
                {{ notification.title }}
              </h6>
              <p class="fs-13 mb-2">{{ notification.message }}</p>
              <p class="fs-13 mb-2">{{ notification.createdAt | date: 'medium' }}</p>
            </div>
            <!-- View Leave Link -->
            <div class="text-end" *ngIf="getLeaveRoute(notification) as route">
              <a
                class="text-primary fw-semibold"
                style="cursor: pointer"
                data-bs-dismiss="modal"
                [routerLink]="route.path"
                [queryParams]="route.queryParams"
              >
                <!-- View Leave -->
                View
              </a>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #noRecords>
        <div class="text-center">Record not available</div>
      </ng-template>

      <!-- pagination -->
      <ng-container *ngIf="notificationList.length > 0">
        <div
          class="d-flex align-items-center justify-content-between ms-2"
          *ngIf="notificationList.length > 0"
        >
          <div>
            Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
            {{ totalCount }} entries
          </div>
          <div class="has-text-centered mt-3">
            <app-pagination
              [currentPage]="currentPage"
              [pageSize]="pageLimit"
              [totalRows]="totalCount"
              (pageChange)="goTopPage($event)"
            ></app-pagination>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <!-- </div> -->
</div>

<!-- Show Popup -->
<div
  class="modal fade"
  id="notificationDetailsModal"
  tabindex="-1"
  aria-labelledby="notificationDetailsLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content model-fixed-height">
      <div class="modal-header">
        <h5 class="modal-title" id="notificationDetailsLabel">
          Notification Details
          <i class="ti ti-circle-check text-success"></i>
        </h5>
        <button
          type="button"
          class="btn-close custom-btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <i class="ti ti-x"></i>
        </button>
      </div>
      <div class="modal-body" *ngIf="selectedNotification">
        <p><strong>Date:</strong> {{ selectedNotification.createdAt | date: 'medium' }}</p>
        <p><strong>Title:</strong> {{ selectedNotification.title }}</p>
        <hr />
        <p><strong>Message:</strong></p>
        <p style="white-space: normal; word-break: break-word">
          {{ selectedNotification.message }}
        </p>
        <!-- View Leave Link -->
        <!-- <div class="mt-2" *ngIf="getLeaveRoute() as route">
          <a
            class="text-primary fw-semibold"
            style="cursor: pointer"
            data-bs-dismiss="modal"
            [routerLink]="route.path"
            [queryParams]="route.queryParams"
          >
            View Leave
          </a>
        </div> -->
      </div>
    </div>
  </div>
</div>
